import { useState, useEffect, createContext, useContext, useCallback } from 'react';
import api from './api';

const SubscriptionContext = createContext(null);

export function SubscriptionProvider({ children }) {
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get('/subscriptions/features');
      setSub(res.data);
    } catch {
      setSub({ plan: 'free', level: 0, features: {}, usage: {} });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) refresh();
    else setLoading(false);
  }, [refresh]);

  return (
    <SubscriptionContext.Provider value={{ sub, loading, refresh }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  const ctx = useContext(SubscriptionContext);
  if (!ctx) return { sub: null, loading: true, refresh: () => {}, canAccess: () => true, isPro: false, isEnterprise: false };
  const { sub, loading, refresh } = ctx;

  const canAccess = (feature) => {
    if (!sub?.features) return true;
    return sub.features[feature]?.allowed !== false;
  };

  const getUsage = (type) => {
    if (!sub?.usage) return { used: 0, limit: -1, remaining: -1 };
    return sub.usage[type] || { used: 0, limit: -1, remaining: -1 };
  };

  return {
    sub,
    loading,
    refresh,
    plan: sub?.plan || 'free',
    isPro: (sub?.level || 0) >= 1,
    isEnterprise: (sub?.level || 0) >= 2,
    canAccess,
    getUsage,
  };
}
